<div class="shw-on-web" *ngIf="currentFilters.length > 0">

  <div class="bs-example filters">
    <div class="accordion left-sidebar mb-5" id="accordionExample">
      <ng-template ngFor [ngForOf]="currentFilters" let-filter let-index="index">
        <div class="card" *ngIf="filter.values.length > 0">
          <div class="card-header" id="{{filter.id}}_ARIA">
            <h2 class="mb-0">
              <button type="button" class="btn btn-link" data-toggle="collapse"
                [attr.data-target]="'#target_' + filter.id" (click)="onOpenFilter(index)">
                <i class="fa fa-plus"></i>
                {{filter.name}}
              </button>
            </h2>
          </div>
          <div id="{{'target_' + filter.id}}" class="collapse" aria-labelledby="{{filter.id}}_ARIA"
            data-parent="#accordionExample">
            <div class="card-body">
              <p *ngFor="let field of filter.values; let fieldIndex=index">
                <label>
                  <input [type]="filter.type" [name]="filter.id" [checked]="field.checked" [value]="field.value"
                    (click)="onAddOnFilter($event, index, fieldIndex)" /> {{field.value}}
                </label>
              </p>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<div class="show-on-mobl">
  <ul class="list-inline f-light ul-style ">
    <li class="list-inline-item">
      <a href="javascript:void(0);" class="fltr-shw">
        Filter By
      </a>
    </li>

  </ul>

  <a href="javascript:;" class="btn btn-filter w-50 mb-2" (click)="showFilters = !showFilters">
    <i class="fa fa-filter"></i>
    Filters
  </a>

</div>



<div class="shwmbl-flter" *ngIf="showFilters && currentFilters.length > 0">
  <div class="fltr-layer"></div>
  <div class="shwmbl-flter-outer">
    <div class="shwmbl-flter-innr">
      <div class="shwmbl-flter-tp">
        <h4 class="small-21">Filters</h4>
        <a href="javascript:void(0);" (click)="clearAll()" class="btn btn-filter">Clear</a>
        <a href="javascript:void(0);" class="btn btn-filter" (click)="showFilters = !showFilters">Done</a>
      </div>
      <div class="bs-example filters">
        <div class="accordion left-sidebar mb-5" id="accordionExample">
          <ng-template ngFor [ngForOf]="currentFilters" let-filter let-index="index">
            <div class="card" *ngIf="filter.values.length > 0">
              <div class="card-header" id="{{filter.id}}_ARIA">
                <h2 class="mb-0">
                  <button type="button" class="btn btn-link" data-toggle="collapse"
                    [attr.data-target]="'#target_' + filter.id" (click)="onOpenFilter(index)">
                    <i class="fa fa-plus"></i>
                    {{filter.name}}
                  </button>
                </h2>
              </div>
              <div id="{{'target_' + filter.id}}" class="collapse" aria-labelledby="{{filter.id}}_ARIA"
                data-parent="#accordionExample">
                <div class="card-body">
                  <p *ngFor="let field of filter.values; let fieldIndex=index">
                    <label>
                      <input [type]="filter.type" [name]="filter.id" [checked]="field.checked" [value]="field.value"
                        (click)="onAddOnFilter($event, index, fieldIndex)" /> {{field.value}}
                    </label>
                  </p>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>